import firebase from 'firebase/app'
import 'firebase/messaging';

// Initialize the Firebase app in the service worker by passing in
// your app's Firebase config object.
// https://firebase.google.com/docs/web/setup#config-object
// DEV Configuration
// const firebaseConfig = {
//     apiKey: "AIzaSyDSN5a_69i1BvT5msfeJWA3nEIruqOF2ak",
//     authDomain: "care-aid-dev.firebaseapp.com",
//     projectId: "care-aid-dev",
//     storageBucket: "care-aid-dev.appspot.com",
//     messagingSenderId: "192581118529",
//     appId: "1:192581118529:web:c01fd7e5d29219d63fb4c0"
// };

// PRODUCTION Configuration
const firebaseConfig = {
    apiKey: "AIzaSyDNkf7IlTJ-Y5cRSdcZaL3w3OogZPvDJCc",
    authDomain: "grounded-access-327310.firebaseapp.com",
    projectId: "grounded-access-327310",
    storageBucket: "grounded-access-327310.appspot.com",
    messagingSenderId: "712931922088",
    appId: "1:712931922088:web:b52482c1738847d495f29d",
    measurementId: "G-6476EL589B"
};

if(!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig)
}

console.log(firebase.name);
// Retrieve an instance of Firebase Messaging so that it can handle background
// messages.
let messaging = null;
if(firebase.messaging.isSupported()) {
    messaging = firebase.messaging();
}

export const getToken = () => {
    if(!messaging) {
        return null;
    }
    return new Promise(resolve => {
        messaging.getToken({vapidKey: process.env.REACT_APP_FIREBASE_VAPIKEY}).then((currentToken) => {
            if (currentToken) {
                console.log('current token for client: ', currentToken);
                resolve(currentToken);
            } else {
                console.log('No registration token available. Request permission to generate one.');
                // setTokenFound(false);
                // shows on the UI that permission is required
            }
        }).catch((err) => {
            console.log('An error occurred while retrieving token. ', err);
            // catch error while creating client token
            resolve(null);
        });
    })
}

export const firebaseMessaging = messaging;
